<template>
  <div class="flex flex-col h-screen items-center justify-center bg-white p-3">
    <Head title="Login" />
    <div class="w-full max-w-md flex flex-col h-full justify-center">
      <logo class="mx-auto block w-full min-h-0 shrink max-h-[140px]" />
      <form
        class="mt-4 [@media(max-height:650px)]:mt-0 overflow-hidden rounded-lg bg-white shadow-xl shrink-0"
        @submit.prevent="form.post($routes.user_session())"
      >
        <div class="px-10 py-12 [@media(max-height:650px)]:py-8">
          <flash-messages />

          <h1
            class="text-center text-3xl font-bold [@media(max-height:650px)]:text-2xl"
          >
            Bine ai venit
          </h1>
          <div
            class="mx-auto mt-6 w-24 border-b-2 [@media(max-height:650px)]:mt-2"
          />
          <text-input
            v-model="form.user.email"
            class="mt-10 [@media(max-height:650px)]:mt-6"
            label="Email"
            type="email"
            autofocus
            autocapitalize="off"
            autocomplete="email"
          />
          <text-input
            v-model="form.user.password"
            class="mt-6"
            label="Parola"
            type="password"
            autocomplete="current-password"
          />
          <label class="mt-6 flex select-none items-center" for="remember">
            <input
              id="remember"
              v-model="form.user.remember_me"
              class="mr-1"
              type="checkbox"
            />
            <span class="text-sm">Ține-mă minte</span>
          </label>
        </div>
        <div
          class="flex border-t border-gray-200 bg-gray-100 px-10 py-4 [@media(max-height:650px)]:py-2"
        >
          <loading-button
            :loading="form.processing"
            class="btn-no-color field-primary-colors ml-auto"
            type="submit"
          >
            Login
          </loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { Head } from '@inertiajs/vue3';
import Layout from '@/Layouts/Minimal.vue';
import FlashMessages from '@/Shared/FlashMessages.vue';
import LoadingButton from '@/Shared/LoadingButton.vue';
import Logo from '@/Shared/Logo.vue';
import TextInput from '@/Shared/TextInput.vue';

export default {
  components: {
    Head,
    FlashMessages,
    LoadingButton,
    Logo,
    TextInput,
  },
  layout: Layout,
  data() {
    return {
      form: this.$inertia.form({
        user: {
          email: '',
          password: '',
          remember_me: null,
        },
      }),
    };
  },
};
</script>
